import { render, staticRenderFns } from "./source-chip.vue?vue&type=template&id=f1149d1a&scoped=true"
import script from "./source-chip.vue?vue&type=script&lang=js"
export * from "./source-chip.vue?vue&type=script&lang=js"
import style0 from "./source-chip.vue?vue&type=style&index=0&id=f1149d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1149d1a",
  null
  
)

export default component.exports